<script setup>
import {computed, onMounted, ref} from "vue";

const props = defineProps({
    id : Number,
    locale : String,
});

const fields = ref([]);

const successMessage = ref(false);

const loadFields = () => {
    axios.get('/api/forms/'+ props.id +'/fields')
        .then(response => {
            fields.value = response.data;

            fields.value.forEach(field => {
                let value = null;

                if (field.type.identifier == 'checkbox') {
                    value = [];
                }

                Vue.set(values.value, 'field-'+ field.id, value);
            });
        });
}

const sending = ref(false);
const siteKey = ref();
const language = ref();

const values = ref({ recaptcha : null, lang : props.locale })
const errors = ref([]);
const recaptchaField = ref();

const send = () => {
    if (sending.value) {
        return;
    }

    sending.value = true;
    axios.post('/api/forms/'+ props.id, values.value)
        .then(response => {
            sending.value = false;
            successMessage.value = response.data.message;
        }).catch(error => {
            if (error.response.data && error.response.data.errors) {
                errors.value = error.response.data.errors;
            }
            sending.value = false;
            values.value.recaptcha = null;
            recaptchaField.value.reset() // Direct call reset method
        });
}


const captchaVerified = (token) => {
    values.value.recaptcha = token;
}

onMounted(() => {
    loadFields();

    language.value = window._locale;
    siteKey.value = window.google_site_key;
});

const canSend = computed(() => {
    if (sending.value) {
        return false;
    }

    return true;
});

const hasError = (field) => {
    return errors.value && errors.value[field] && errors.value[field].length > 0;
}
</script>
<template>
    <div v-if="successMessage" class="alert alert-success mb-0">
        {{ successMessage }}
    </div>
    <div v-else>
        <div class="row">
            <div class="mb-3" :class="'col-md-'+ field.col_width" v-for="field in fields">
                <label class="form-label">{{ field.title[locale] }}<sup v-if="field.required">*</sup></label>

                <input type="text" v-model="values['field-'+ field.id]" class="form-control" :class="{ 'is-invalid' : hasError('field-'+ field.id) }" v-if="!field.type || field.type.identifier == 'textfield'">
                <textarea v-model="values['field-'+ field.id]" v-else-if="field.type.identifier == 'textarea'" class="form-control" :class="{ 'is-invalid' : hasError('field-'+ field.id) }" rows="5"></textarea>
                <div v-else-if="['radio', 'checkbox'].includes(field.type.identifier)" :class="{ 'is-invalid' : hasError('field-'+ field.id) }">
                    <div class="form-check" v-for="option in field.answer_options">
                        <input class="form-check-input" :type="field.type.identifier" :value="option.label[locale]" v-model="values['field-'+ field.id]" :id="'answerOption-'+ option.id">
                        <label class="form-check-label" :for="'answerOption-'+ option.id">
                            {{ option.label[locale] }}
                        </label>
                    </div>
                </div>

                <div class="invalid-feedback" v-if="hasError('field-'+ field.id)">
                    <span v-for="error in errors['field-'+ field.id]">{{ error }}</span>
                </div>
            </div>
        </div>
        <div class="mb-3">
            <recaptcha ref="recaptchaField" :language="language" :sitekey="siteKey" v-if="siteKey" @verify="captchaVerified"></recaptcha>
            <div class="invalid-feedback d-block" v-if="hasError('recaptcha')">
                <span v-for="error in errors.recaptcha">{{ error }}</span>
            </div>
        </div>
        <button class="btn btn-lg btn-primary text-white" :class="{ disabled : !canSend }" @click="send"><i class="fa fa-spin fa-circle-notch" v-if="sending"></i> {{ __('Send') }} <i class="fa fa-chevron-right"></i></button>
    </div>
</template>
